import React from "react";
import Select from "common/Select/Select";
import { FormFieldTitle } from "features/bots/common/styles";
import { BaselineSelectProps } from "@shared/features/bots/BotForm/common/types";
import { useBaselineSelect } from "@shared/features/bots/BotForm/common/hooks";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { translateOptionName } from "@shared/common/i18n/optionNames";

const BaselineSelect = ({
  value,
  onChange,
  titleText,
  placeholder,
  titleStyle,
  orderType,
}: BaselineSelectProps) => {
  const { options, helperData } = useBaselineSelect({ orderType });

  return (
    <div>
      <FormFieldTitle
        as="div"
        style={{ display: "flex", alignItems: "center", ...titleStyle }}
      >
        {titleText}
        <HelperTooltip
          {...helperData}
          tooltipStyle={{ width: 300 }}
          maxWidth={300}
        />
      </FormFieldTitle>
      <Select
        style={{ width: "100%" }}
        value={value}
        onChange={onChange}
        popupMatchSelectWidth={false}
        optionLabelProp="label"
        placeholder={placeholder}
        options={options.map((option) => ({
          value: option.value,
          label: translateOptionName(option.name),
        }))}
        mobileTitle={titleText}
      />
    </div>
  );
};

export default BaselineSelect;
